import Leads from './leads'
import Business from './business'
import Matrimonial from './matrimonial'
import Job from './job'

const Table = {
  Leads,
  Business,
  Matrimonial,
  Job
}

export default Table
